export { PrizeCard } from './PrizeCard';
